import React from "react";
import styled from "@emotion/styled";
import {useTheme} from "@emotion/react";

/*
    props
    width : string = 툴팁 길이
    content : string
 */
const CustomTooltip = (props) => {
    // css style
    const {view} = useComponentStyle(props.width);

    return (
        <div>
            <view.TooltipContent>{props.content && props.content}</view.TooltipContent>
            <view.TooltipArrow />
        </div>
    );
};

export default CustomTooltip;

export const useComponentStyle = (width) => {
    const theme = useTheme();
    return {
        view: {
            TooltipContent: styled.div({
                position: "absolute",
                display: "flex",
                justifyContent: "center",
                flexWrap: "nowrap",
                top: "-40px",
                left: "-30px",
                zIndex: "1001",
                width: width || "250px",
                height: "30px",
                padding: "8px",
                boxSizing: "border-box",
                borderRadius: "10px",
                backgroundColor: theme.colors.tooltip,
                fontSize: "14px",
                lineHeight: "14px",
                color: theme.colors.w,
            }),
            TooltipArrow: styled.div({
                position: "absolute",
                top: "-24px",
                left: "0",
                width: "20px",
                height: "20px",
                backgroundColor: theme.colors.tooltip,
                transform: "rotate(45deg)",
                borderRadius: "3px",
                boxShadow: theme.box_shadow,
            }),
        },
    };
};
